import { render, staticRenderFns } from "./odemearacicomp.vue?vue&type=template&id=1791d8fd&"
import script from "./odemearacicomp.vue?vue&type=script&lang=js&"
export * from "./odemearacicomp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports